// src/api/axiosConfig.js
import axios from 'axios';
import { toast } from 'react-toastify';

// 1) point *all* calls at /api
// Use localhost for local development, fallback to environment variable
const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Handle case where REACT_APP_API_URL already includes /api
const baseUrl = apiUrl.endsWith('/api') ? apiUrl : `${apiUrl}/api`;
axios.defaults.baseURL = baseUrl;
console.log('🔧 Axios configured - baseURL:', baseUrl, 'from apiUrl:', apiUrl);
axios.defaults.withCredentials = true;

// 2) auto-attach bearer token
axios.interceptors.request.use(cfg => {
  const t = localStorage.getItem('token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// 2.5) Fix double /api path issue  
axios.interceptors.request.use(cfg => {
  if (cfg.url?.includes('/api/api/')) {
    console.log('🔧 Fixing duplicate API path:', cfg.url);
    cfg.url = cfg.url.replace('/api/api/', '/api/');
  }
  return cfg;
});

// 3) on 401, try your /auth/refresh once
axios.interceptors.response.use(
  res => res,
  async err => {
    const cfg = err.config;
    if (err.response?.status === 401 && !cfg.__isRetry) {
      cfg.__isRetry = true;
      try {
        // because baseURL ends with /api, this hits /api/auth/refresh
        const { data } = await axios.post('/auth/refresh');
        localStorage.setItem('token', data.accessToken);
        cfg.headers.Authorization = `Bearer ${data.accessToken}`;
        return axios.request(cfg);
      } catch (refreshErr) {
        console.error('Token refresh failed:', refreshErr);
        // Clear stored credentials
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('userId');
        
        toast.error('Session expired. Please log in again.');
        // Use a more reliable redirect method
        setTimeout(() => {
          window.location.href = '/login';
        }, 1000);
      }
    }
    return Promise.reject(err);
  }
);
